// Utilidades de las pantallas de Programación (envíos y documentos)

// Fecha local en formato YYYY-MM-DD (toISOString devuelve la fecha en UTC y puede cambiar de día)
export function fechaLocal(fecha) {
  const d = new Date(fecha)
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const dia = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${mes}-${dia}`
}

// Escapa texto para insertarlo en HTML (contenidos de eventos y avisos con datos que ingresan los clientes)
export function escaparHtml(texto) {
  return String(texto === null || texto === undefined ? '' : texto)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
